import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const partnerInquiryFields = [
  "gaming_partnerinquiryid", // UID
  "statecode", // State
  "statuscode", // Status Reason
  "gaming_name", // Text
  "gaming_inquirytype", // Choice
  "gaming_inquirystatus", // Choice
  "gaming_ndaattemptcount", // Whole Number
  "gaming_ndaattemptlastdate", // Date and Time
  "gaming_ndaattemptlasterror", // Multiple Lines of Text
  "gaming_ndacontractnumber", // Text
  "gaming_ndacontractssystemid", // Text
  "gaming_ndasentdate", // Date and Time
  "gaming_ndasigneddate", // Date and Time
  "gaming_ndastatus", // Choice
  "gaming_descriptionotherinformation", // Multiple Lines of Text
  "gaming_requestedchangevalue", // Text
  "gaming_supportingdocument", // File
  "gaming_RelatedAccount", // Lookup - account
  "gaming_PrimaryContactforInquiry", // Lookup - contact
  "gaming_HubLastUpdateByContactid", // Lookup - contact
] as const;

export const partnerInquiryReferences: EntityReferences<EntityName.gaming_partnerinquiry> = {
  [EntityName.account]: ["gaming_RelatedAccount"],
  [EntityName.contact]: ["gaming_PrimaryContactforInquiry", "gaming_HubLastUpdateByContactid"],
};

export const partnerInquiryKey: AnyEntityField<EntityName.gaming_partnerinquiry> =
  "gaming_partnerinquiryid";
